/**
 * Convert markdown to plain text while preserving information.
 */
export function stripMarkdown(text: string): string {
  return text
    // Headers
    .replace(/^#{1,6}\s+(.+)$/gm, '$1')
    // Bold
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/__(.+?)__/g, '$1')
    // Italic
    .replace(/\*(.+?)\*/g, '$1')
    .replace(/_(.+?)_/g, '$1')
    // Inline code
    .replace(/`([^`]+)`/g, '$1')
    // Code blocks
    .replace(/```[a-z]*\n([\s\S]*?)```/g, '$1')
    // Links
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1 ($2)')
    // Images
    .replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '$1 (image: $2)')
    // Blockquotes
    .replace(/^>\s+(.+)$/gm, '  $1')
    // Unordered lists
    .replace(/^[\*\-]\s+(.+)$/gm, '• $1')
    // Ordered lists
    .replace(/^\d+\.\s+(.+)$/gm, '$1')
    // Horizontal rules
    .replace(/^---+$/gm, '————————————')
    // Remove any remaining escape characters
    .replace(/\\(.)/g, '$1')
}
